import { render } from "./materialIcon2.vue?vue&type=template&id=4c88481f"
import script from "./materialIcon2.vue?vue&type=script&lang=js"
export * from "./materialIcon2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__